import { toast } from "react-toastify";

type Options = {
  type?: string,
};
export default (message: any, options?: Options = { type: "info" }) => {
  toast.configure({ ...options });
  toast[options.type](message);
};
